import { render, staticRenderFns } from "./ModalContactAdd.vue?vue&type=template&id=349035e0&scoped=true&"
import script from "./ModalContactAdd.vue?vue&type=script&lang=js&"
export * from "./ModalContactAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349035e0",
  null
  
)

export default component.exports